import * as yup from 'yup';

export const metadataSchema = yup.object().shape({
  title: yup.string().trim().required('Title is required').max(100, 'Title maximum 100 characters'),
  description: yup
    .string()
    .trim()
    .required('Description is required')
    .max(2000, 'Description maximum 2000 characters'),
  equityPercentage: yup
    .string()
    .trim()
    .required('Equity percentage is required')
    .matches(/^\d+(\.\d+)?$/, 'Equity percentage must be a number')
    .test('is-in-range', 'Equity percentage must be between 1 and 100', (value) => {
      const numValue = parseFloat(value);
      return numValue >= 0 && numValue <= 100;
    })
    .test('is-large-zero', 'Equity percentage must be greater than 0', (value) => {
      const numValue = parseFloat(value);
      return numValue > 0;
    })
    .test('is-in-range', 'Equity percentage must be an integer', (value) => {
      return Number.isInteger(Number(value));
    }),
  contentTypeIds: yup
    .array()
    .min(1, 'Content type is required')
    .required('Content type is required')
});
